export default __webpack_public_path__ + "static/media/PoweredBy_en.9a37bcc8.png";